import { createApp } from 'vue'
import GtmTracker from './GtmTracker'

const el = '.kb-component--gtm-tracker'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((GtmTrackerDOM) => {
            const trackJson = GtmTrackerDOM.dataset.trackJson
            const trackData = trackJson ? JSON.parse(trackJson) : null
            const component = createApp(GtmTracker, { trackData }).use(Store)
            component.mount(GtmTrackerDOM)
        })
    }
}
